import { render, staticRenderFns } from "./carplatematchrule.vue?vue&type=template&id=7c712b26&"
import script from "./carplatematchrule.vue?vue&type=script&lang=js&"
export * from "./carplatematchrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports